var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle--discount_svg__a",
    height: 18,
    maskUnits: "userSpaceOnUse",
    width: 18,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle--discount_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45 16.875l-1.425-2.4-2.7-.6.263-2.775L.75 9l1.838-2.1-.263-2.775 2.7-.6 1.425-2.4L9 2.212l2.55-1.087 1.425 2.4 2.7.6-.263 2.775L17.25 9l-1.837 2.1.262 2.775-2.7.6-1.425 2.4L9 15.788zm1.762-5.213l4.238-4.237-1.05-1.087-3.188 3.187L6.6 7.95 5.55 9z",
    fill: "#5fb846"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--discount-b7197d93646658de3deeb9b447c14487.svg";
export { SvgIconCircleDiscount as Component };